'use strict';

module.exports = function (variable) {
    //get query params and remove the beginning '?'
    var query = window.location.search.substring(1);

    //split on ampersand
    var vars = query.split('&');

    //loop through 'vars' array
    for (var i = 0; i < vars.length; i++) {
        // split on '=' to give key value pairs
        var pair = vars[i].split('=');

        // if key matchs key supplied to function
        if (pair[0] === variable) {
            // return the value of the param that has matched
            return pair[1];
        }
    }

    return false;
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/get-query-var.js
// module id = 185
// module chunks = 0